import {Component, Input, OnDestroy, OnInit, Output, EventEmitter} from '@angular/core';
import {Studies} from '../model/recruiter.model';
import {StudiesService} from '../../shared/services/studies.service';
import {MatSidenav} from '@angular/material/sidenav';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-show',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class ShowComponent implements OnInit, OnDestroy {
  @Input() recruiterData: any;
  @Input() allStudies: Studies;
  @Output() editEvent = new EventEmitter<boolean>();
  @Input() inputSideNav: MatSidenav;
  @Output() close: EventEmitter<any> = new EventEmitter();

  fetchedStudies: Studies;
  formatedStudy: any = [];
  assignedStudy: boolean = false;
  recruiterStudy: any = [];
  public selectedStudy = [];
  public study_count: any;
  public assigned_study_id: any = [];
  formStatus = false;
  statusClass: string;
  responseMessage:string;
  responseIcon: string;
  active = true;
  editFlag: any;
  showFlag: any

  constructor(private studiesService: StudiesService, private snackBar: MatSnackBar) {
  }

  ngOnInit() {
    this.fetchedStudies = this.allStudies;
    this.editFlag = false;
    this.showFlag = true
    if(this.fetchedStudies != undefined){ 

    this.formatStudyFn(this.fetchedStudies.result);
    }
    return this.studiesService.getStudyByRecruiter(this.recruiterData.id).subscribe(
      data => {
        if (data.responseCode == 1) {
          this.study_count = data.study_count;
          if(data.result != undefined){ 
          data.result.filter(study => {
            this.recruiterStudy.push(study);
          });
        }
          this.assignedStudy = true
        } else {
        }
      },
    )

  }

  formatStudyFn(value: any) {
    value.filter(study => {
      this.formatedStudy.push({name: study.study_details.study_name, id: study.study_details.id});
    });
  }

  selectedStudyHandler($event: any) {
    this.selectedStudy = $event;
  }

  onStudyAssign() {
    this.assigned_study_id = [];
    this.selectedStudy.filter(study => this.assigned_study_id.push(study.id));
    this.studiesService.assignStudy({recruiter_id: this.recruiterData.id, study: this.assigned_study_id.toString()}).subscribe(data => {
      if ( data.responseCode == 1){
        this.formStatus = true;
        this.statusClass = 'success';
        this.responseIcon ='check_circle_outline';
        this.responseMessage = 'You have updated successfully';
      }
      else{
        this.formStatus = true;
        this.statusClass = 'fail';
        this.responseIcon ='error_outline';
        this.responseMessage = 'Oops ! Error'
      }
    })
  }

  ngOnDestroy(): void {
    this.recruiterData = {};
  }
  onClose(){
    this.close.emit();
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
    });


  }
  onEdit(){
    this.editFlag = true;
    this.showFlag = false;

    // this.editEvent.next(true);
  }
  scrollToTarget(element: HTMLElement){
    element.scrollIntoView(true);
  }
}
